import moment from 'moment'
import { Logger } from '~/plugins/log'
const logger = new Logger()
logger.setContext('Insta')

const getDefaultState = () => ({
  posts: [],
  count: null,
  lastUpdate: null
})

export const state = getDefaultState

export const mutations = {
  SET (state, posts) {
    const allPosts = [...state.posts, ...posts]
    state.posts = []
    allPosts.forEach((post) => {
      if (state.posts.find(p2 => p2.id === post.id)) return
      state.posts.push(post)
    })
    state.lastUpdate = (new Date()).valueOf()
  },
  SET_COUNT (state, count) {
    state.count = count
  },
  RESET (state) {
    Object.assign(state, getDefaultState())
  }
}

export const getters = {
  posts: state => state.posts.sort((a, b) => {
    return moment(b.mediadate) - moment(a.mediadate)
  }),
  loaded: state => state.posts.length,
  count: state => state.count,
  postsForProducts: (state, getters) => (products, limit = 9) => {
    return getters.posts.filter((post) => {
      return products.some(product => post.sku.startsWith(product.split('-')[0]))
    }).slice(0, limit)
  }
}

export const actions = {
  async GET ({ commit, state, getters }) {
    try {
      const { data } = await this.$publicAPI.get(`insta/?limit=40&offset=${getters.loaded}`, { useCache: true })
      commit('SET', data.results)
      commit('SET_COUNT', data.count)
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET_LATEST ({ commit }) {
    try {
      const { data } = await this.$publicAPI.get('insta/?limit=1')
      commit('SET', data.results)
      commit('SET_COUNT', data.count)
      return data.results[0]
    } catch (error) {
      this.app.$sentry.captureException(error)
      logger.error(error)
    }
  },
  async GET_FOR_PRODUCTS ({ getters, dispatch }, products) {
    // Fetch posts until we have at least 8 posts for the requested products
    while (getters.postsForProducts(products) < 8 && getters.loaded < 200) {
      await dispatch('GET')
    }
  }
}
